import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CampaignWizard from '../../campaign-wizard/CampaignWizard';
import campaignService from '../../../services/campaign.service';
import { useEyeconxStore } from '../../../store/eyeconxStore';

function CreateEmail() {
    const navigate = useNavigate();
    const clinicId = useEyeconxStore((state) => state.user?.clinicId);

    const steps = [
        { id: 1, title: 'Select Template', subtitle: 'Choose a template or start blank', component: 'TemplateSelection' },
        { id: 2, title: 'Blast Information', subtitle: 'Basic information', component: 'CampaignInformation' },
        { id: 3, title: 'Subject Line', subtitle: 'Subject line for email', component: 'SubjectLine' },
        { id: 4, title: 'Content', subtitle: 'Main content of the email', component: 'EmailContent' },
        { id: 5, title: 'Patient List', subtitle: 'Select patients that will receive email', component: 'PatientList' },
        { id: 6, title: 'Complete', subtitle: 'Process the Blast', component: 'Complete' },
    ];

    const handleSubmit = async (formData) => {
        const name = formData.campaignName?.trim();
        const title = formData.subjectLine?.trim();
        const htmlContent = formData.htmlContent?.trim();
        const patientIds = (formData.selectedPatients || [])
            .map((patient) => patient.id)
            .filter(Boolean);

        if (!clinicId) {
            toast.error('Clinic is not available. Please sign in again.');
            return;
        }
        if (!name) {
            toast.error('Blast name is required.');
            return;
        }
        if (!title) {
            toast.error('Email subject is required.');
            return;
        }
        if (!htmlContent) {
            toast.error('Email content is required.');
            return;
        }
        if (patientIds.length === 0) {
            toast.error('Select at least one patient before launching.');
            return;
        }

        try {
            const response = await campaignService.launchEmailBlast(clinicId, {
                name,
                description: formData.description?.trim() || undefined,
                title,
                htmlContent,
                jsonContent: formData.jsonContent || undefined,
                patientIds,
            });
            const recipientCount = response.data?.recipientCount ?? patientIds.length;
            toast.success(
                `Email blast submitted for ${recipientCount} recipient${recipientCount === 1 ? '' : 's'}. Queueing runs in the background.`
            );
            navigate('/blast/email');
        } catch (error) {
            console.error('Failed to launch email blast', error);
            toast.error(error?.response?.data?.errorMessage || 'Could not launch email blast.');
            throw error;
        }
    };

    return (
        <CampaignWizard
            title="Create Email Blast"
            description="Communicate with patients using email."
            icon="bi-send"
            navigatePath="/blast/email"
            campaignType="email"
            entityLabel="Blast"
            steps={steps}
            onSubmit={handleSubmit}
        />
    );
}

export default CreateEmail;
